import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-with-reason-dialog',
  templateUrl: './confirm-with-reason-dialog.component.html',
  styleUrls: ['./confirm-with-reason-dialog.component.scss']
})
export class ConfirmWithReasonDialogComponent implements OnInit {

  selectedReasonCode: string;

  reasons = [];

  constructor(
    public dialogRef: MatDialogRef<ConfirmWithReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.reasons = data.reasons;
  }

  ngOnInit(): void {
  }

  cancelClicked() {
    this.dialogRef.close({ confirmButtonClicked: false, cancelButtonClicked: true });
  }

  confirmClicked() {
    this.dialogRef.close({ confirmButtonClicked: true, cancelButtonClicked: false, reasonCode: this.selectedReasonCode });
  }

}
